import axios from "axios";

const idToken = localStorage.getItem("token");
const envData = process.env.REACT_APP_API_URL;

if(idToken === null || idToken === undefined) {
    console.log('token invalid')
}
export default axios.create({
    baseURL: envData,
    headers : {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken
    }
});